<script>
//Repositories
import Repositories from '@/repositories';
const DashboardsRepository = Repositories.get('dashboards');

//Mixins
import textMixin from '@/mixins/textMixin';
import dateMixin from '@/mixins/dateMixin';
import statusMixin from '@/mixins/statusMixin';

//Components
import GridComponent from '@/components/widgets/grids/api-linked-grid';

export default {
  props: {
    filters: Object,
    fields: Array,
    totalInventoryPrices: Object,
  },
  components: {
    GridComponent,
  },
  mixins: [textMixin, dateMixin, statusMixin],
  data() {
    return {
      inventoryPrices: [],
      fullListSize: 0,
      gridContext: null,
      isLoading: false,
    };
  },
  created() {
    this.gridContext = {
      currentPage: 1,
      perPage: this.itemsPerPage,
      sortBy: 'code',
      sortDesc: false,
    };

    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      DashboardsRepository.customREST
        .getInventoryPrices({ ...this.filters, ...this.gridContext })
        .then(({ data }) => {
          this.inventoryPrices = data.data;
          this.fullListSize = data.count;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    contextChanged(context) {
      this.gridContext = context;
      this.loadData();
    },
  },
  computed: {
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
    itemsPerPage() {
      return this.$store.getters['localstorage/getDynamicConfigs'](
        'gridConfig-dashboard-prices-grid'
      ).itemsPerPage;
    },
  },
  watch: {
    filters() {
      this.inventoryPrices = [];
      this.gridContext.currentPage = 1;
      this.loadData();
    },
  },
};
</script>

<template>
  <b-card no-body class="p-3 custom-inventory-shadow">
    <GridComponent
      v-if="gridContext != null"
      id="dashboard-prices-grid"
      :fields="fields"
      :items="inventoryPrices"
      :is-busy="isLoading"
      :nbItems="fullListSize"
      :default-sort="gridContext.sortBy"
      :current-page="gridContext.currentPage"
      @context-changed="contextChanged"
    >
      <template #cell(code)="data">
        <span
          v-html="
            highlightMatches(
              data.item.code,
              filters != null ? filters.search : ''
            )
          "
        ></span>
      </template>

      <template #cell(name)="data">
        <span
          v-html="
            highlightMatches(
              data.item.name,
              filters != null ? filters.search : ''
            )
          "
        ></span>
      </template>

      <template #cell(defaultSupplierPrice)="data">
        {{ currencyFormatter.format(data.item.defaultSupplierPrice) }}
      </template>

      <template #cell(totalOrderedPrice)="data">
        {{ currencyFormatter.format(data.item.totalOrderedPrice) }}
      </template>

      <template #cell(totalInventoryPrice)="data">
        {{ currencyFormatter.format(data.item.totalInventoryPrice) }}
      </template>

      <template #cell(totalPrice)="data">
        {{ currencyFormatter.format(data.item.totalPrice) }}
      </template>

      <template v-if="totalInventoryPrices != null" #custom-foot="data">
        <td
          v-for="(column, index) in data.fields"
          :key="column.key"
          style="font-weight: 600; font-size: 1.05em"
        >
          <div v-if="column.key == 'totalOrderedPrice'" class="centered-field">
            {{
              currencyFormatter.format(totalInventoryPrices.totalOrderedPrice)
            }}
          </div>
          <div
            v-else-if="column.key == 'totalInventoryPrice'"
            class="centered-field"
          >
            {{
              currencyFormatter.format(totalInventoryPrices.totalInventoryPrice)
            }}
          </div>
          <div v-else-if="column.key == 'totalPrice'" class="centered-field">
            {{ currencyFormatter.format(totalInventoryPrices.totalPrice) }}
          </div>
          <div v-else-if="index == 0">Total </div>
        </td>
      </template>
    </GridComponent>
  </b-card>
</template>